export function orderReturnedValidate(order){
    var result = true;
    
    result = validateId(order.id);
    result = validateUniqueOrderNumber(order.unique_order_number);
    result = validateShipmentNumber(order.shipment_number);
    result = validateOrderReturned(order.order_returned);
    result = validateDetails(order.details);

    return result;
}

function validateId(id) {
    return typeof id === 'number'
}

function validateUniqueOrderNumber(unique_order_number) {
    if(typeof unique_order_number === 'string' && unique_order_number.trim() !== '') return true;
    else return false;
}

function validateShipmentNumber(shipment_number) {    
    if(typeof shipment_number === 'string' && shipment_number.trim() !== '') return true;
    else return false;
}

function  validateOrderReturned(order_returned) {
    return typeof order_returned === 'object' && 
    typeof order_returned.id === "number" &&
    typeof order_returned.shipment_id === "number" && 
    typeof order_returned.conditions === "string" &&
    typeof order_returned.return_date === "string" &&
    typeof order_returned.return_with_damaged_reported === "boolean" &&
    typeof order_returned.warehouse_id === "number" &&
    typeof order_returned.created_at === "string" &&
    typeof order_returned.updated_at === "string" 
}

function validateDetails(details) {
    return Array.isArray(details) &&
        details.every(item =>
        typeof item === 'object' &&
        item !== null &&
        item.id && typeof item.id === "number" &&
        typeof item.detail_order_id === "number" &&
        typeof item.detailed_stock_id === "number" &&
        typeof item.product_id === "number" &&
        typeof item.damaged_product === "number" &&
        typeof item.quantity === "number" &&
        typeof item.stolen_product === "number" &&
        typeof item.date === "string" &&
        typeof item.details_order_returneds_id === "number" &&
        typeof item.sku === "string"
    );
}